// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 20/11/2023
 */

.SelectAddress_headingContainer__U52tR {
    display: flex;
    justify-content: space-between;
}

.SelectAddress_closeButton__pFL6Y {
    padding: 0.2rem;
    border: 1px #5A9BD8 solid;
    color: #5A9BD8;
}

.SelectAddress_addAddressContainer__cwPM0 {
    padding: 1rem 0;
    border-bottom: 1px solid #5A9BD8;
}

.SelectAddress_addressContainer__Hsxqf {
    padding: 0.5rem;
    padding-top: 1rem;
}

.SelectAddress_submitButton__eF\\+rs {
    width: 100%;
    border-radius: 0.5rem;
    margin-top: 1rem;
}

.SelectAddress_dialog__uvOqE{
    border-radius: 0.5rem;
background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/SelectAddress.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB,gGAAgG;AAChG","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 20/11/2023\r\n */\r\n\r\n.headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #5A9BD8 solid;\r\n    color: #5A9BD8;\r\n}\r\n\r\n.addAddressContainer {\r\n    padding: 1rem 0;\r\n    border-bottom: 1px solid #5A9BD8;\r\n}\r\n\r\n.addressContainer {\r\n    padding: 0.5rem;\r\n    padding-top: 1rem;\r\n}\r\n\r\n.submitButton {\r\n    width: 100%;\r\n    border-radius: 0.5rem;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.dialog{\r\n    border-radius: 0.5rem;\r\nbackground: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `SelectAddress_headingContainer__U52tR`,
	"closeButton": `SelectAddress_closeButton__pFL6Y`,
	"addAddressContainer": `SelectAddress_addAddressContainer__cwPM0`,
	"addressContainer": `SelectAddress_addressContainer__Hsxqf`,
	"submitButton": `SelectAddress_submitButton__eF+rs`,
	"dialog": `SelectAddress_dialog__uvOqE`
};
export default ___CSS_LOADER_EXPORT___;
